import { setShoppingCart } from './../../shared/plugins/http-service';
import { getHttp, getShoppingCart, postHttp } from "shared/plugins/http-service";
import {
  ORDER_API,
  SHOPPING_CART_API, SHOPPING_CART_API_ADD_ITEM, SHOPPING_CART_API_APPLY_COUPON, SHOPPING_CART_API_CREATE_ORDER, SHOPPING_CART_API_REMOVE_COUPON, SHOPPING_CART_API_REMOVE_ITEM, SHOPPING_CART_API_UPDATE_ADDRESS, SHOPPING_CART_API_UPDATE_ITEM, SHOPPING_WEBSITE_ADD_ITEMS_CART_API, SHOPPING_WEBSITE_APPLY_COUPON_CART_API, SHOPPING_WEBSITE_REMOVE_COUPON_CART_API, SHOPPING_WEBSITE_REMOVE_ITEM_CART_API, SHOPPING_WEBSITE_UPDATE_ITEM_CART_API
} from "shared/constants/api-endpoint";
import { AddItemModel, ApplyCouponModel, CartModel, OrderModel, UpdateAddressModel, UpdateItemModel, WebsiteAddShoppingCartItemModel, WebsiteRemoveCouponShoppingCartModel, WebsiteRemoveShoppingCartItemModel,  WebsiteUpdateShoppingCartItemModel } from "./cart.models";
export const getCartApi = async () => {
  const response = await getHttp<CartModel>(
    `${process.env.REACT_APP_API_URI}${SHOPPING_CART_API}`
  );
  return response;
};

export const createItemCartApi = async (model: AddItemModel) => {
  const response = await postHttp(
    `${process.env.REACT_APP_API_URI}${SHOPPING_CART_API_ADD_ITEM}`,model
  );
  return response;
};

export const removeItemCartApi = async (skuId: number | string) => {
  const response = await postHttp(
    `${process.env.REACT_APP_API_URI}${SHOPPING_CART_API_REMOVE_ITEM}`,
    {skuId: skuId}
  );
  return response;
};
export const updateItemCartApi = async (model: UpdateItemModel) => {
  const response = await postHttp(
    `${process.env.REACT_APP_API_URI}${SHOPPING_CART_API_UPDATE_ITEM}`,model
  );
  return response;
};
export const updateAddressCartApi = async (model: UpdateAddressModel) => {
  const response = await postHttp(
    `${process.env.REACT_APP_API_URI}${SHOPPING_CART_API_UPDATE_ADDRESS}`
    ,model
  );
  return response;
};
export const applyCouponCartApi = async (model: ApplyCouponModel) => {
  const response = await postHttp(
    `${process.env.REACT_APP_API_URI}${SHOPPING_CART_API_APPLY_COUPON}`,model
  );
  return response;
};
export const removeCouponCartApi = async () => {
  const response = await postHttp(
    `${process.env.REACT_APP_API_URI}${SHOPPING_CART_API_REMOVE_COUPON}`
  );
  return response;
};
export const createCartApi = async () => {
  const response = await postHttp<number>(
    `${process.env.REACT_APP_API_URI}${SHOPPING_CART_API_CREATE_ORDER}`
  );
  return response;
};

export const getOrderApi = async (id: string | number) => {
  const response = await getHttp<OrderModel>(
    `${process.env.REACT_APP_API_URI}${ORDER_API}/${id}`
  );
  return response;
};

export const addItemsShoppingCartApi = async (model: WebsiteAddShoppingCartItemModel) => {
  model.shoppingCart = JSON.parse(getShoppingCart() ?? "");
  const response = await postHttp<OrderModel>(
    `${process.env.REACT_APP_API_URI}${SHOPPING_WEBSITE_ADD_ITEMS_CART_API}`,model
  );
  setShoppingCart(JSON.stringify(response.data));
  return response;
};

export const updateItemShoppingCartApi = async (model: WebsiteUpdateShoppingCartItemModel) => {
  model.shoppingCart = JSON.parse(getShoppingCart() ?? "");
  const response = await postHttp<OrderModel>(
    `${process.env.REACT_APP_API_URI}${SHOPPING_WEBSITE_UPDATE_ITEM_CART_API}`,model
  );
  setShoppingCart(JSON.stringify(response.data));
  return response;
};

export const removeItemShoppingCartApi = async (model: WebsiteRemoveShoppingCartItemModel) => {
  model.shoppingCart = JSON.parse(getShoppingCart() ?? "");
  const response = await postHttp<OrderModel>(
    `${process.env.REACT_APP_API_URI}${SHOPPING_WEBSITE_REMOVE_ITEM_CART_API}`,model
  );
  setShoppingCart(JSON.stringify(response.data));
  return response;
};

export const removeCouponShoppingCartApi = async (model: WebsiteRemoveCouponShoppingCartModel) => {
  model.shoppingCart = JSON.parse(getShoppingCart() ?? "");
  const response = await postHttp<OrderModel>(
    `${process.env.REACT_APP_API_URI}${SHOPPING_WEBSITE_REMOVE_COUPON_CART_API}`,model
  );
  setShoppingCart(JSON.stringify(response.data));
  return response;
};
export const applyCouponShoppingCartApi = async (model: WebsiteRemoveCouponShoppingCartModel) => {
  model.shoppingCart = JSON.parse(getShoppingCart() ?? "");
  const response = await postHttp<OrderModel>(
    `${process.env.REACT_APP_API_URI}${SHOPPING_WEBSITE_APPLY_COUPON_CART_API}`,model
  );
  setShoppingCart(JSON.stringify(response.data));
  return response;
};



